export default "__VITE_ASSET__e3aeb460__"